import { SettingsParser } from "../../settings-parser";
import { MarkPlotSettings } from "../../../settings/view-objects/plot/mark-plot-settings";
import { getSizeSettings } from "../../../../utils/get-size-settings";
import { ColorConverter, ObjectCreator } from "../../../../../../../web-graphics";

export class MarkPlotSettingsParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = [
      "id_mark",
      "type",
      "place", // "central","aboveCentral","underCentral","bottom","bottomCentral","top","topCentral","left","leftCentral","right","rightCentral"
      "x_axis", // '0' place on X axis: left, right
      "y_axis", // '0' place on Y axis: top, down
      "y",
      "x",
      "min_x_space",
      "min_y_space",
      "width",
      "height",
      "color"
    ];
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      return undefined;
    }
    const parsedColorText = ObjectCreator.merge(settings.color, defaultSettings?.color);
    const colorParsingResult = ColorConverter.convertToWebglRgba(parsedColorText);
    return {
      id_mark: settings.id_mark,
      type: settings.type,
      place: (settings.place ?? defaultSettings?.place) ?? "central",
      x_axis: (settings.x_axis ?? defaultSettings?.x_axis) ?? "left",
      y_axis: (settings.y_axis ?? defaultSettings?.y_axis) ?? "down",
      y: getSizeSettings(settings.y, 0, 0),
      x: getSizeSettings(settings.x, 0, 0),
      min_x_space: settings.min_x_space,
      min_y_space: settings.min_y_space,
      width: getSizeSettings(settings.width, 0, 1),
      height: getSizeSettings(settings.height, 0, 1),
      color: colorParsingResult.value
    };
  }

  parse(settings, defaultSettings) {
    const parsedSettings = MarkPlotSettingsParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new MarkPlotSettings(parsedSettings);
  }
}
